import styles from './Container.module.scss';
import className from 'classnames/bind';

let cx = className.bind(styles);

export function Container({ children, className }) {
  const classNameArray = className?.split(' ') || [];

  return (
    <div className={cx(['ns_container', 'container', ...classNameArray])}>
      {children}
    </div>
  );
}
